import { Grid, Stack } from "@mui/material";
import React, { Component } from "react";
import { Button } from "../../components/Button";
import { Paper } from "../../components/Paper";
import { Organization } from "../../data/Organization";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";
import Drawing from "../../resources/images/drawing-inactive.svg";

class InactiveViewBase extends Component<any & WithLocaleProps, any> {
  constructor(props: any) {
    super(props);

    this.state = this.generateMessage(props.user, props.organization);
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.user !== this.props.user || prevProps.organization !== this.props.organization)
      this.generateMessage(this.props.user, this.props.organization);
  }

  generateMessage(user: any, organization: any) {
    if (organization && organization.status === Organization.status.inactive) {
      if (user && user.isBillingUser) {
        if (organization.isTrial)
          return {
            headingKey: "inactive.trialExpired",
            messageKey: "inactive.trialExpiredBillingMessage",
            actions: ["contactUs", "buyNow"]
          };
        else
          return {
            headingKey: "inactive.organizationDisabled",
            messageKey: "inactive.organizationDisabledBillingMessage",
            actions: ["contactUs"]
          };
      } else {
        if (organization.isTrial)
          return {
            headingKey: "inactive.trialExpired",
            messageKey: "inactive.trialExpiredMessage",
            actions: null
          };
        else
          return {
            headingKey: "inactive.organizationDisabled",
            messageKey: "inactive.organizationDisabledMessage",
            actions: null
          };
      }
    }
    return {
      headingKey: "inactive.noAccess",
      messageKey: "inactive.noAccessMessage",
      actions: null
    };
  }

  onContactClick(e: any) {
    const { onContactClick } = this.props;
    if (onContactClick) onContactClick(e);
  }

  onBuyClick(e: any) {
    const { onBuyClick } = this.props;
    if (onBuyClick) onBuyClick(e);
  }

  render() {
    const { headingKey, messageKey, actions } = this.state;
    const { translate } = this.props;

    return (
      <Paper className='klayo-inactiveuserview' padding='44px 64px 48px 64px'>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <h1>{translate(headingKey)}</h1>
            <div className='klayo-inactiveuserview_message'>{translate(messageKey)}</div>
            <Stack direction='row' className='klayo-inactiveuserview_actions' spacing={2}>
              {actions && actions.includes("contactUs") && (
                <Button
                  label={translate("inactive.contactUs")}
                  onClick={this.onContactClick.bind(this)}
                />
              )}

              {actions && actions.includes("buyNow") && (
                <Button
                  variant='filled'
                  label={translate("inactive.buyNow")}
                  onClick={this.onBuyClick.bind(this)}
                />
              )}
            </Stack>
          </Grid>
          <Grid item xs={6} className='klayo-inactiveuserview_drawing'>
            <Drawing />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export const InactiveView = withLocale(InactiveViewBase);
